import React from 'react'

import { makeIcon } from 'components/Utils/Icons'

export const DirectoryIcon = makeIcon({
  displayName: 'DirectoryIcon',
  content: (
    <path d="M10.5 9.75V4.125L6.75 4.125C5.50736 4.125 4.5 3.11764 4.5 1.875H1.5V9.75L10.5 9.75ZM12 4.125V9.75C12 10.5784 11.3284 11.25 10.5 11.25H1.5C0.671573 11.25 0 10.5784 0 9.75V1.875C0 1.04657 0.671573 0.375 1.5 0.375H4.5C5.32843 0.375 6 1.04657 6 1.875C6 2.28921 6.33579 2.625 6.75 2.625H10.5C11.3284 2.625 12 3.29657 12 4.125Z" />
  ),
})
